<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="修改邮箱"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="cc-step">
          <div class="step-warrp">
            <div class="step-header-warrp">
              <div
                :class="['step-item', { active: navStepCurrent >= item.id }]"
                v-for="item in stepList"
                :key="item.id"
              >
                <span>{{ item.id }}</span>
              </div>
            </div>
            <div class="step-content">
              <div
                :class="[
                  'step-item-text',
                  { active: navStepCurrent >= item.id },
                ]"
                v-for="item in stepList"
                :key="item.id"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <template v-if="navStepCurrent === 1">
          <div class="col">
            <div class="name">验证方式：</div>
            <Select v-model="checkType" size="large" :disabled="codeDisabled">
              <Option v-for="item in checkTypeList" :key="item.value" :value="item.value" :label="item.name"></Option>
            </Select>
          </div>
          <div class="col">
            <div class="name">{{checkType === 0 ? '手机号码：' : '邮箱：'}}</div>
            <Input
              class="height45"
              :value="checkType === 0 ? user.mobile : user.email"
              disabled
              clearable
            />
          </div>
          <div class="col">
            <div class="name">验证码：</div>
            <div class="row">
              <Input
                class="height45"
                v-model="form.code"
                @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
                placeholder="请输入验证码"
                style="width: 200px"
                clearable
              />
              <smsBtn
                ref="smsBtn"
                height="45px"
                shape=""
                @tap="getCodeEvent"
                style="width: 120px; margin-left: 30px"
              ></smsBtn>
            </div>
          </div>
        </template>
        <template v-if="navStepCurrent === 2">
          <div class="col">
            <div class="name">邮箱：</div>
            <Input
              class="height45"
              v-model="form.newEmail"
              placeholder="请输入手机号码"
              style="width: 200px"
              clearable
            />
          </div>
        </template>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userEmailUpdate, smsSend, postVerifyCode } from "api/customer.js";
import { mapMutations, mapState } from "vuex";
import smsBtn from "components/smsBtn.vue";
import loading from "components/loading.vue";

export default {
  name: "updateEmailModal",
  components: {
    smsBtn,
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      navStepCurrent: 1,
      stepList: [
        {
          id: 1,
          name: "验证身份",
        },
        {
          id: 2,
          name: "设置新的邮箱",
        },
      ],
      checkType: 0,
      checkTypeList: [],
      form: {
        code: "",
        newEmail: "",
        verifyCode: "",
      },
      loading: false,
      codeDisabled: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.onShow()
    }, 500)
  },
  methods: {
    ...mapMutations(["MUT_USER_INFO_EMAIL"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.codeDisabled = false;
      this.$refs.smsBtn && this.$refs.smsBtn.reset();
      this.visibility = false;
    },
    onShow() {
      this.form = this.$options.data().form;
      this.navStepCurrent = 1;
      this.codeDisabled = false;
      this.$refs.smsBtn && this.$refs.smsBtn.reset();
      this.checkTypeList = []
      if (this.user.mobile != null && this.user.mobile.length > 0) {
        this.checkType = 0
        this.checkTypeList.push({
          value: 0,
          name: '手机验证'
        })
      } else {
        this.checkType = 1
      }
      if (this.user.email != null && this.user.email.length > 0) {
        this.checkTypeList.push({
          value: 1,
          name: '邮箱验证'
        })
      }
    },
    async onConfirm() {
      try {
        if (this.navStepCurrent === 1) {
          if (!this.form.code) {
            this.$Message.warning("请输入验证码！");
            return false;
          }
          this.loading = true;
          const { code, data } = await postVerifyCode({ code: this.form.code, type: this.checkType });
          this.loading = false;
          if (code === 200) {
            this.form.verifyCode = data.verifyCode;
            this.codeDisabled = false;
            this.$refs.smsBtn.reset();
            this.navStepCurrent = 2;
          }
        } else if (this.navStepCurrent === 2) {
          if (!this.form.newEmail) {
            this.$Message.warning("请输入邮箱！");
            return false;
          }
          this.loading = true;
          let params = {
            yx: this.form.newEmail,
            ver: this.form.verifyCode,
          };
          const { code } = await userEmailUpdate(params);
          this.loading = false;
          if (code === 200) {
            this.MUT_USER_INFO_EMAIL(this.form.newEmail);
            this.$emit("submit-success", (res) => {
              if (res) {
                this.navStepCurrent = 1;
                this.onCancel();
                this.$Message.success("认证邮件已发送，请尽快验证！");
              }
            });
          }
          this.$refs.smsBtn.reset();
        }
      } catch (error) {
        this.loading = false;
        this.$refs.smsBtn.reset();
      }
    },
    // 获取验证码
    getCodeEvent(callback) {
      smsSend(this.checkType)
        .then((res) => {
          if (res.code === 200 && res.result) {
            this.codeDisabled = true;
            callback(true);
          }
        })
        .catch(() => {
          this.codeDisabled = false;
          this.$refs.smsBtn.reset();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
  }
}
</style>

<style lang="less" scoped>
.cc-step {
  width: 300px;
  margin: 0 auto;
}
.step-warrp {
  .step-header-warrp {
    display: flex;
    .step-item {
      flex: 1;
      display: flex;
      align-items: center;
      &:first-child {
        &::before {
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
        }
      }
      &:last-child {
        &::after {
          border-top-right-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
      span {
        display: inline-block;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 50%;
        color: #333;
        font-size: 16px;
        font-weight: bold;
        background-color: #f4f7fe;
        border: 1px solid #b1b1b1;
      }
      &::before,
      &::after {
        content: "";
        flex: 1;
        height: 4px;
        background-color: #d6d6d6;
      }
    }
    .step-item.active {
      span {
        color: #fff;
        background-color: #2d8cf0;
        border: none;
      }
      &::before,
      &::after {
        background-color: #2d8cf0;
      }
    }
  }
  .step-content {
    display: flex;
    .step-item-text {
      flex: 1;
      text-align: center;
      margin-top: 20px;
      color: #333333;
      font-weight: bold;
    }
    .step-item-text.active {
      color: #2d8cf0;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
